export default class scrollDown {
    constructor() {
        this.init();
    }

    init() {
        let scrollDown = document.querySelector(
            ".primary-section__scroll-down"
        );
        if (scrollDown) {
            document.addEventListener("scroll", () => {
                if (window.scrollY > 50) {
                    scrollDown.style.opacity = 0;
                } else {
                    scrollDown.style.opacity = 1;
                }
            });
        }
    }
}
